import { CompleteInitializationAction, EntityDiagramActionFn } from '../types';

export const completeInitializationAction: EntityDiagramActionFn<
  CompleteInitializationAction
> = (state, _action, _queueEffect) => {
  return { ...state, isInitializing: false };
};
